import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsTechnical extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Technical Issues and Troubleshooting</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>I am facing issues with the RailYatri mobile app. How do I get help?</h3>
                            <p>In-App Help Section: Open the RailYatri app, navigate to the "Feedback" section from the main menu (left side), and submit your query. Additionally, you can email your concerns directly to care@railyatri.in for further assistance</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if the website is not working properly?</h3>
                            <p>If the RailYatri website is not working properly, try these steps:<br/>
                                Clear Browser Cache: Clear your browser cache via the settings to resolve issues.<br/>
                                Try a Different Browser: Switch to a different web browser to see if the issue persists.<br/>
                                Check Internet Connection: Ensure that your internet connection is stable and functioning properly.<br/>
                                Contact Support: If the issue continues, take screenshots of the problem and report it by emailing RailYatri’s support team at care@railyatri.in or by using the ""Feedback"" option in the mobile app.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I clear the app cache to resolve issues?</h3>
                            <p>To clear the app cache for the RailYatri app and potentially resolve issues, follow these steps:<br/>
                                For Android:<br/>
                                Step 1: Open Settings - Apps &gt; RailYatri &gt; Storage & Cache &gt; Clear Cache.</p>

                                <p>For iOS:<br/>
                                Unfortunately, iOS does not have a direct option to clear the cache of individual apps. To resolve issues, you can try uninstalling and reinstalling the app.</p>

                                <p>For Website:<br/>
                                To clear cache for the website in your browser, follow these steps:</p>

                                <p>1. Chrome (Desktop):<br/>
                                Click the three dots in the top-right corner.<br/>
                                Select "More Tools" &gt; "Clear Browsing Data".<br/>
                                Check "Cached images and files" and click "Clear Data."<br/>
                                2. Safari (Mac):<br/>
                                Click "Safari" in the menu bar.<br/>
                                Go to "Preferences" &gt; "Privacy."<br/>
                                Click "Manage Website Data" and choose "Remove All."</p>

                                <p>Clearing the cache can resolve many app and website issues by removing temporary files that may be causing problems.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I report a bug or technical issue on the app/website?</h3>
                            <p>Send an email to care@railyatri.in</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if I encounter an error during the booking process?</h3>
                            <p>Feel free to call our RailYatri customer support at +91 8010 500 300 immediately if you encounter any issues during the booking process.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I update the RailYatri app to the latest version?</h3>
                            <p>To update the RailYatri app to the latest version, follow these steps:</p>

                                <p>For Android: Go to Google Play Store &gt; Search RailYatri &gt; Tap "Update" if available.
                                For iOS: Go to App Store &gt; Search RailYatri &gt; Tap "Update" if available.</p>

                                <p>Alternatively, you can enable automatic updates on your device to ensure you always have the latest version of the app.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsTechnical);
